module.exports = __webpack_public_path__ + "img/gold-coin2.b3c3f6ef.png";